<template>
  <div class="row">
    <div class="col-md-6" data-v-step="5">
      <div class="row">
        <div class="col-md-12 px-gap">
          <div id="db-tren-medkon" class="bg-white p-l-20 p-t-20 p-r-20 p-b-10 rounded shade"
            style="position: relative; max-height: 366px" data-v-step="5">
            <h5 class="no-margin" align="center">
              Data Tren Media Online
            </h5>
            <div v-if="data.display_tipe == 1 && !isloading" class="p-t-10 subscribe-overlay" align="center"
              style="height: 310px">
              <i class="bi bi-bar-chart-steps"></i>
              <p>
                Lihat perkembangan topik yang Anda monitor pada platform Media
                TV, Media Cetak, dan Berita Online.
              </p>
              <subscribe-btn />
            </div>
            <div class="p-t-10">
              <loader-component v-if="isloading" />
              <div v-else-if="!data.data_tren_formed" class="col-md-12 col-sm-12 col-lg-12">
                <div class="alert alert-danger mt-3" id="errorApiEl" role="alert" align="center">
                  <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                  Silahkan lakukan pencarian dengan parameter lain
                </div>
              </div>
              <div v-else>
                <div v-if="isMedkonDisable" class="alert alert-danger mt-3">
                  <center>
                    <strong>Data Tidak Tersedia !</strong>
                    <p>
                      Aktifkan Channel Media Online untuk Melihat Data
                      Tren Media Online
                    </p>
                  </center>
                </div>
                <line-chart-component v-else :series="data.data_tren_formed" :event="data.event_linechart_medkon"
                  el="linechart-dashboard-mockup" mode="dual" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 mt-md-0 m-t-10" data-v-step="6">
      <div class="row">
        <div class="col-md-12 px-gap">
          <div id="db-tren-medsos" class="bg-white p-l-20 p-t-20 p-r-20 p-b-10 rounded shade" style="max-height: 366px">
            <h5 class="no-margin" align="center">
              Data Tren Media Sosial
              <div class="pull-right" align="right">
                <div class="form-check form-check-inline switch">
                  <input type="checkbox" v-model="showReach" id="pagesSwitchTrenMedsos" />
                  <label for="pagesSwitchTrenMedsos">Jangkauan Tren</label>
                </div>
              </div>
            </h5>
            <div v-if="data.display_tipe == 2 && !isloading" class="p-t-10 subscribe-overlay" align="center"
              style="max-height: 310px">
              <i class="bi bi-bar-chart-steps"></i>
              <p>
                Lihat perkembangan topik yang Anda monitor di Twitter, Facebook,
                Instagram dan sosial media lainnya.
              </p>
              <subscribe-btn />
            </div>
            <div v-if="isloading" class="p-t-10">
              <loader-component />
            </div>
            <div v-else class="p-t-10" style="max-height: 310px">
              <div v-if="!data.data_tren_reach && !data.data_tren_medsos" class="col-md-12 col-sm-12 col-lg-12">
                <div class="alert alert-danger mt-3" id="errorApiEl" role="alert" align="center">
                  <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                  Silahkan lakukan pencarian dengan parameter lain
                </div>
              </div>
              <line-chart-component v-if="showReach" :key="keybar" :series="data.data_tren_reach"
                :event="data.event_linechart_medsos" el="linechart-medsos" mode="dual" :is_engagement_reach="true" />
              <div v-else>
                <div v-if="isMedsosDisable" class="alert alert-danger mt-3">
                  <center>
                    <strong>Data Tidak Tersedia !</strong>
                    <p>
                      Aktifkan Channel Media Sosial untuk Melihat Data Tren
                      Media Sosial
                    </p>
                  </center>
                </div>
                <line-chart-component v-else :series="data.data_tren_medsos" :key="keybar"
                  :event="data.event_linechart_medsos" el="linechart-tren-reach" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader_component from "@/views/components/loader.vue";
import line_chart from "@/views/components/chart/line_chart.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "tren_medkon_medsos",
  components: {
    "loader-component": loader_component,
    "line-chart-component": line_chart,
  },
  props: {
    data: Object,
    isloading: Boolean,
  },
  data() {
    return {
      showReach: false,
      keybar: 0,
      media: this.$store.getters.user.project.project_detail.crawler,
    };
  },
  computed: {
    isMedsosDisable() {
      if (
        this.media.facebook.status == 0 &&
        this.media.instagram.status == 0 &&
        this.media.linkedin.status == 0 &&
        this.media.tiktok.status == 0 &&
        this.media.twitter.status == 0 &&
        this.media.youtube.status == 0 &&
        this.media.google.blog_status == 0 &&
        this.media.google.forum_status == 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    isMedkonDisable() {
      if (
        this.media.formed.cetak_status == 0 &&
        this.media.formed.tv_status == 0 &&
        this.media.google.news_status == 0
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    showReach() {
      this.keybar++;
    },
  },
  filters: {
    number_format: function (number) {
      return gp.kmbFormatter(number);
    },
  },
};
</script>